import { render, staticRenderFns } from "./panel-item-sidebar.vue?vue&type=template&id=61bfef60&scoped=true&"
import script from "./panel-item-sidebar.js?vue&type=script&lang=js&"
export * from "./panel-item-sidebar.js?vue&type=script&lang=js&"
import style0 from "./panel-item-sidebar.scss?vue&type=style&index=0&id=61bfef60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bfef60",
  null
  
)

component.options.__file = "panel-item-sidebar.vue"
export default component.exports